import React from "react"
import { Link } from "gatsby"
import "./Footer.scss"
import LrtLogo from "../../assets/svg/lrt-logo.svg"
import MmoLogo from "../../assets/svg/lslogowh.png"
import FbLogo from "../../assets/svg/facebook.svg"
import LongArrowRight from "../../assets/svg/long-arrow-right.svg"

export default () => (
  <footer className="footer">
    <div className="container">
      <div>Organizatoriai</div>

      <div className="footer--organisators">
        <a
          href="https://lrt.lt"
          rel="noopener noreferrer"
          target="_blank"
          title="LRT"
        >
          <img src={LrtLogo} alt="LRT" />
        </a>
        <a
          href="https://osp.stat.gov.lt"
          rel="noopener noreferrer"
          target="_blank"
          title="Lietuvos statistika"
        >
          <img src={MmoLogo} alt="Lietuvos statistika" />
        </a>
      </div>


      <div className="dn-mobile">
        <Link to="/privacy-policy" title="Privatumo politika">
          Privatumo politika
        </Link>
      </div>
    </div>
  </footer>
)
